import {
  GET_PLC_SAFETY_EVENT_BY_ID,
  GET_PLC_SAFETY_EVENT_BY_ID_SUCCESS,
  GET_PLC_SAFETY_EVENT_BY_ID_ERROR,
} from './actionTypes';

export const getPlcSafetyEventById = (user, eventId) => ({
  type: GET_PLC_SAFETY_EVENT_BY_ID,
  payload: { user, eventId },
});

export const getPlcSafetyEventByIdSuccess = (event) => ({
  type: GET_PLC_SAFETY_EVENT_BY_ID_SUCCESS,
  payload: { event },
});

export const getPlcSafetyEventByIdError = (error) => ({
  type: GET_PLC_SAFETY_EVENT_BY_ID_ERROR,
  payload: error,
});
